import React, { useState } from "react";
import UploadPdf from "../../../RequestedProposal/UploadPdf";
import ProposalList from "../../../RequestedProposal/ProposalList";

export default function Documents({ details }) {
  const [isCalled, setIsCalled] = useState(false);

  return (
    <>
      <div className="MainContainer" style={{ marginTop: "2vh" }}>
        <div>
          <UploadPdf projectId={details?.id} setIsCalled={setIsCalled} />
          <br />
          <ProposalList
            arr={details?.proposal_files}
            setIsCalled={setIsCalled}
          />
        </div>
      </div>
    </>
  );
}
